import {
    liquidGlassPressTransition,
    LIQUID_GLASS_PRESS_SCALE,
} from '@focuslee/shared-mini-app';
import { motion } from 'framer-motion';
import React from 'react';

export type AnimatedQuestItemProps = {
    overdue: boolean;
    justCompleted: boolean;
    pressed?: boolean;
    children: React.ReactNode;
};

export const AnimatedQuestItem = ({ children, overdue, justCompleted, pressed = false }: AnimatedQuestItemProps) => {
    const borderWidth = justCompleted ? 2 : overdue ? 1 : 0;
    const borderColor = justCompleted
        ? 'var(--tg-theme-button-color)'
        : overdue
            ? 'var(--tg-theme-destructive-text-color)'
            : 'transparent';

    return (
        <motion.div
            initial={false}
            exit={{
                opacity: 0,
                height: 0,
                scale: 0.95,
                marginBottom: 0,
                paddingTop: 0,
                paddingBottom: 0,
                borderLeftWidth: 0,
                borderRightWidth: 0,
                borderTopWidth: 0,
                borderBottomWidth: 0,
            }}
            animate={{
                scale: justCompleted ? 1.05 : pressed ? LIQUID_GLASS_PRESS_SCALE : 1,
                backgroundColor: justCompleted ? 'var(--tg-theme-button-color)' : 'transparent',
                borderLeftWidth: borderWidth,
                borderRightWidth: borderWidth,
                borderTopWidth: borderWidth,
                borderBottomWidth: borderWidth,
                borderLeftColor: borderColor,
                borderRightColor: borderColor,
                borderTopColor: borderColor,
                borderBottomColor: borderColor,
            }}
            transition={{
                opacity: { duration: 0.3 },
                height: { duration: 0.3, ease: 'easeInOut' },
                scale: liquidGlassPressTransition,
                backgroundColor: { duration: 0.3, ease: 'easeInOut' },
                marginBottom: { duration: 0.3, ease: 'easeInOut' },
                paddingTop: { duration: 0.3, ease: 'easeInOut' },
                paddingBottom: { duration: 0.3, ease: 'easeInOut' },
                borderLeftWidth: { duration: 0.3, ease: 'easeInOut' },
                borderRightWidth: { duration: 0.3, ease: 'easeInOut' },
                borderTopWidth: { duration: 0.3, ease: 'easeInOut' },
                borderBottomWidth: { duration: 0.3, ease: 'easeInOut' },
                borderLeftColor: { duration: 0.3, ease: 'easeInOut' },
                borderRightColor: { duration: 0.3, ease: 'easeInOut' },
                borderTopColor: { duration: 0.3, ease: 'easeInOut' },
                borderBottomColor: { duration: 0.3, ease: 'easeInOut' },
            }}
            style={{
                overflow: 'hidden',
                position: 'relative',
                borderRadius: '12px',
                borderStyle: 'solid',
                zIndex: justCompleted ? 10 : undefined,
            }}
        >
            {children}
        </motion.div>
    );
};
